module.exports = __webpack_public_path__ + "img/ic_bolt_black_24dp@2x.d76a3145.png";